import React from "react";
import PropTypes from "prop-types"

const Dropdown = (props) => (
	<form>
		<select value = { props.value } onChange = { props.onChange } >
			{
				props.children
			}
		</select>
	</form>
);

Dropdown.Option = (props) => (
	<option value = { props.value } >
		{
			props.children
		}
	</option>
);

Dropdown.Option.propTypes = { 
	children: PropTypes.string,
};

export default Dropdown;
